module.exports = __webpack_public_path__ + "img/pole-red.b5757a96.jpg";